import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { ErrorHandlerService } from '../error-handler/error-handler.service';
import { ROUTES } from '../api/api.constants';
import { GymProvider } from 'src/app/providers/GymProvider';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api/api.service';
import { VersionProvider } from 'src/app/providers/VersionProvider';
import { UpdatesSystemComponent } from 'src/app/components/updates-system/updates-system.component';
import { UserProvider } from 'src/app/providers/UserProvider';
import { SideMenuService } from '../sideMenu/side-menu.service';
import { RolServiceService } from '../rol/rol-service.service';
import { ToastService } from '../toast/toast.service';



@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private storage: Storage,
    private errorHandler: ErrorHandlerService,
    private gymProvider: GymProvider,
    public translate: TranslateService,
    public userProvider: UserProvider,
    private api: ApiService,
    private versionProvider:VersionProvider,
    private modalController:ModalController,
    private rolservice:RolServiceService,
    private sideMenuService:SideMenuService,
    private toastService:ToastService,
  ) { }


  public async isAuthenticated(): Promise<boolean> {
    const token: any = await this.storage.get("token");
    if(token) {
      const user = await this.storage.get('user');
      if(!user) return false;

      let userInfo = await this.gymProvider.showApp(user.id_gimnasio);
      if(userInfo.errors && userInfo.errors[0]=="Unauthorized"){
        return false
      }
      return true
    }
    return false;
  }
  
  async openUpdateView(){
    const popover = await this.modalController.create({
      component: UpdatesSystemComponent,
      cssClass: 'popoverUpdates'
    });
     await popover.present();
  }
/**
 * Autentica el usuario
 * @param data [email,contraseña]
 * @returns userdata o null
 */
  
  public async authenticateV2(data: { email: string, password: string }, base_url) {
    return fetch(base_url + ROUTES.authentication, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: data.email,
        password: data.password,
      })
    })
      .then(this.errorHandler.handleErrors)
      .then(async (response) => {
        if(!response.data){
          let error=response.errores?'GYM_INACTIVE_CONTACT_AN_ADMINISTRATOR':'INCORRECT_MAIL_OR_PASSWORD'
          this.toastService.present(this.translate.instant('LOGIN.'+error),1000,'danger');
          return null
        }
        if (response.data.id_rol == 6) {
          this.toastService.present(this.translate.instant('LOGIN.ATHLETES_DONT_HAVE_PERMISSION'),1000,'danger');
          return null
        } 
        await this.storage.set('token', response.data.token);
        this.api.setheaders();
        return response;
      
      })
      .catch(async (error) => {
        this.toastService.present(error,2000,'danger');
        
      });
  }

  async setUser(response) {
    let tutorialShow = await this.storage.get('tutoShow');
    let lan = await this.storage.get('language');
    let show_update = await this.storage.get('show_update');

    await this.storage.clear();
    if(!response.data.permissions)
      response.data.permissions = this.rolservice.getOdenPermissionsByRol(response.data.id_rol);
    await this.storage.set('user', response.data);
    await this.storage.set('tutoShow', tutorialShow);
    await this.storage.set('language', lan);
    await this.storage.set('sectionOld', 1);
    await this.storage.set('token', response.data.token);
    this.api.setheaders();
    
    await this.storage.set('local_version', await this.versionProvider.get())
    //  this.router.navigateByUrl('/');
    if (show_update == null) {
      await this.storage.set('show_update', true)
    }
    this.sideMenuService.userStoreUpdated.emit(response.data);
    let subscription = await this.gymProvider.getGymSubscription(response.data.id_gimnasio)
    if (subscription.success) {
      await this.storage.set('gymSubscription', subscription);
    }
  }
  public async authenticateWithToken(token) {
    const lan = await this.storage.get('language');
    await this.storage.clear();
    await this.storage.set('language', lan);
    await this.storage.set('token', token);
    await this.api.setheadersV2();
    try {
      let user = await this.userProvider.getUserAuth();
      if (!user) {
        await this.toastService.present('Error al autenticar usuario',5000,'danger');
        await this.storage.clear();
        return null;
      }
      if (!user.permissions)
        user.permissions = this.rolservice.getOdenPermissionsByRol(user.id_rol);
      await this.storage.set('user', user)
      this.sideMenuService.userStoreUpdated.emit(user);
      const gym_subscription = await this.gymProvider.getGymSubscription(user.id_gimnasio);
      if (gym_subscription.success)
        await this.storage.set('gymSubscription', gym_subscription);
      return user;
      //this.router.navigate(['/dashboard']);
    } catch (error) {
      await this.toastService.present('Error al autenticar usuario',5000,'danger');
      await this.storage.clear();
      return null;
    }
  }
}
